import { get } from 'svelte/store';
import { userSettings } from '../store/ui';

export const getAudio = (name: string) => {
    return window.__assets_cache[name];
};

let soundEnabled = false;
let musicEnabled = false;

export const playAudio = (
    source: string | Howl,
    options = { volume: 0.25, loop: false, fade: null },
    isMusic = false
) => {
    if (isMusic && !musicEnabled) return;
    if (!isMusic && !soundEnabled) return;
    if (typeof source === 'string') {
        source = window.__assets_cache[source];
    }

    source.loop(options.loop);

    if (options.fade?.to) {
        source.fade(options.fade.from || 0, options.fade.to, options.fade.duration);
    } else {
        source.volume(options.volume);
    }

    return source.play();

    // const context = window.AudioContext || window.webkitAudioContex
    // const audioContext = new context()
    //
    // // Create the node that will play our previously decoded buffer
    // const bufferSourceNode = audioContext.createBufferSource()
    // bufferSourceNode.buffer = buffer
    // bufferSourceNode.loop = loop
    //
    // //set volume
    // const gainNode = audioContext.createGain()
    // gainNode.gain.value = volume // 50 % of volume
    // gainNode.connect(audioContext.destination)
    //
    // // Hook up the buffer source to our output node (speakers, headphones, etc.)
    // bufferSourceNode.connect(gainNode)
    //
    // // Start playing... right now
    // bufferSourceNode.start(0)
};

export const playAudioOnPageLoad = (sound: Howl) => {
    const us = get(userSettings);
    soundEnabled = us.soundEnabled;
    musicEnabled = us.musicEnabled;
    userSettings.subscribe(value => {
        soundEnabled = value.soundEnabled;
        musicEnabled = value.musicEnabled;
    });

    sound.on('playerror', function () {
        sound.once('unlock', function () {
            sound.play();
        });
    });
    return sound.play();
};

export const stopAudio = (buffer: Howl, options = { fade: null }) => {
    const fadeDuration = options?.fade?.duration || 3000;

    if (options.fade) {
        buffer.fade(buffer.volume(), 0, fadeDuration);

        const fadeStopTimeout = setTimeout(() => {
            buffer.stop();
            clearTimeout(fadeStopTimeout);
        }, fadeDuration);
    } else {
        buffer.stop();
    }
};
